import { WifiOff, RefreshCw } from 'lucide-react';
import { useOfflineStatus, offlineManager } from '../../lib/offline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function OfflineBanner() {
  const { isOnline, pendingCount } = useOfflineStatus();
  const { t } = useTranslation();
  const [syncing, setSyncing] = useState(false);

  if (isOnline && pendingCount === 0) return null;

  const handleSync = async () => {
    setSyncing(true);
    try {
      const result = await offlineManager.syncPendingChanges();
      if (result.failed > 0) {
        console.warn(`Sync: ${result.success} succeeded, ${result.failed} failed`);
      }
    } catch (e) {
      console.error('Sync failed:', e);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className={`fixed top-0 left-0 right-0 z-[1200] text-center py-2 px-4 text-sm font-medium transition-colors ${
      isOnline
        ? 'bg-amber-100 dark:bg-amber-900/80 text-amber-800 dark:text-amber-200'
        : 'bg-red-100 dark:bg-red-900/80 text-red-800 dark:text-red-200'
    }`}>
      <div className="flex items-center justify-center gap-2">
        {!isOnline ? (
          <>
            <WifiOff size={16} />
            <span>{t('offline.banner')}</span>
          </>
        ) : pendingCount > 0 ? (
          <>
            <span>{t('offline.pendingSync', { count: pendingCount })}</span>
            <button
              onClick={handleSync}
              disabled={syncing}
              className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded bg-amber-200 dark:bg-amber-800 hover:bg-amber-300 dark:hover:bg-amber-700 text-amber-900 dark:text-amber-100 text-xs font-semibold transition-colors"
            >
              <RefreshCw size={12} className={syncing ? 'animate-spin' : ''} />
              {syncing ? t('offline.syncing') : t('offline.syncNow')}
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}
